export const countries = [
    { 'code': 'AF', 'name': 'Afghanistan' },
    { 'code': 'AL', 'name': 'Albanien' },
    { 'code': 'DZ', 'name': 'Algeriet' },
    { 'code': 'AS', 'name': 'Amerikansk Samoa' },
    { 'code': 'US', 'name': 'USA' },
    { 'code': 'AD', 'name': 'Andorra' },
    { 'code': 'AO', 'name': 'Angola' },
    { 'code': 'AI', 'name': 'Anguilla' },
    { 'code': 'AG', 'name': 'Antigua og Barbuda' },
    { 'code': 'AR', 'name': 'Argentina' },
    { 'code': 'AM', 'name': 'Armenien' },
    { 'code': 'AW', 'name': 'Aruba' },
    { 'code': 'AU', 'name': 'Australien' },
    { 'code': 'AZ', 'name': 'Aserbajdsjan' },
    { 'code': 'BS', 'name': 'Bahamas' },
    { 'code': 'BH', 'name': 'Bahrain' },
    { 'code': 'BD', 'name': 'Bangladesh' },
    { 'code': 'BB', 'name': 'Barbados' },
    { 'code': 'BE', 'name': 'Belgien' },
    { 'code': 'BZ', 'name': 'Belize' },
    { 'code': 'BJ', 'name': 'Benin' },
    { 'code': 'BM', 'name': 'Bermuda' },
    { 'code': 'BT', 'name': 'Bhutan' },
    { 'code': 'BO', 'name': 'Bolivia' },
    { 'code': 'BA', 'name': 'Bosnien - Hercegovina' },
    { 'code': 'BW', 'name': 'Botswana' },
    { 'code': 'BV', 'name': 'Bouvetøen' },
    { 'code': 'BR', 'name': 'Brasilien' },
    { 'code': 'IO', 'name': 'British Indian Ocean Territory' },
    { 'code': 'BN', 'name': 'Brunei' },
    { 'code': 'BG', 'name': 'Bulgarien' },
    { 'code': 'BF', 'name': 'Burkina Faso' },
    { 'code': 'BI', 'name': 'Burundi' },
    { 'code': 'CA', 'name': 'Canada' },
    { 'code': 'KY', 'name': 'Caymanøerne' },
    { 'code': 'CL', 'name': 'Chile' },
    { 'code': 'CX', 'name': 'Juleøen Juleøen' },
    { 'code': 'CO', 'name': 'Colombia Colombia' },
    { 'code': 'CK', 'name': 'Cookøerne' },
    { 'code': 'CR', 'name': 'Costa Rica' },
    { 'code': 'CU', 'name': 'Cuba' },
    { 'code': 'CW', 'name': 'Curaçao' },
    { 'code': 'DK', 'name': 'Danmark' },
    { 'code': 'DJ', 'name': 'Djibouti' },
    { 'code': 'DM', 'name': 'Dominica' },
    { 'code': 'DO', 'name': 'Dominikanske Republik' },
    { 'code': 'EC', 'name': 'Ecuador Ecuador' },
    { 'code': 'EG', 'name': 'Egypten' },
    { 'code': 'CI', 'name': 'Elfenbenskysten' },
    { 'code': 'GQ', 'name': 'Ækvatorialguinea' },
    { 'code': 'SV', 'name': 'El Salvador' },
    { 'code': 'ER', 'name': 'Eritrea' },
    { 'code': 'EE', 'name': 'Estland' },
    { 'code': 'ET', 'name': 'Etiopien' },
    { 'code': 'FK', 'name': 'Falklandsøerne' },
    { 'code': 'FJ', 'name': 'Fiji' },
    { 'code': 'PH', 'name': 'Filippinerne' },
    { 'code': 'FI', 'name': 'Finland' },
    { 'code': 'FR', 'name': 'Frankrig' },
    { 'code': 'GF', 'name': 'Fransk Guiana' },
    { 'code': 'PF', 'name': 'Fransk Polynesien' },
    { 'code': 'TF', 'name': 'Franske Sydterritorier' },
    { 'code': 'FO', 'name': 'Færøerne' },
    { 'code': 'GA', 'name': 'Gabon' },
    { 'code': 'GM', 'name': 'Gambia' },
    { 'code': 'GE', 'name': 'Georgien' },
    { 'code': 'GH', 'name': 'Ghana' },
    { 'code': 'GI', 'name': 'Gibraltar' },
    { 'code': 'GD', 'name': 'Grenada' },
    { 'code': 'GL', 'name': 'Grønland' },
    { 'code': 'GP', 'name': 'Guadeloupe' },
    { 'code': 'GU', 'name': 'Guam' },
    { 'code': 'GT', 'name': 'Guatemala' },
    { 'code': 'GN', 'name': 'Guinea' },
    { 'code': 'GW', 'name': 'Guinea - Bissau' },
    { 'code': 'GY', 'name': 'Guyana' },
    { 'code': 'HT', 'name': 'Haiti' },
    { 'code': 'HM', 'name': 'Heard - øen og McDonald - øerne' },
    { 'code': 'GR', 'name': 'Grækenland' },
    { 'code': 'HN', 'name': 'Honduras' },
    { 'code': 'HK', 'name': 'Hongkong' },
    { 'code': 'BY', 'name': 'Hviderusland' },
    { 'code': 'IN', 'name': 'Indien' },
    { 'code': 'ID', 'name': 'Indonesien' },
    { 'code': 'IQ', 'name': 'Irak' },
    { 'code': 'IR', 'name': 'Iran' },
    { 'code': 'IE', 'name': 'Irland' },
    { 'code': 'IS', 'name': 'Island' },
    { 'code': 'IL', 'name': 'Israel' },
    { 'code': 'JM', 'name': 'Jamaica' },
    { 'code': 'IT', 'name': 'Italien' },
    { 'code': 'JP', 'name': 'Japan' },
    { 'code': 'YE', 'name': 'Yemen' },
    { 'code': 'VG', 'name': 'Britiske Jomfruøer' },
    { 'code': 'VI', 'name': 'Amerikanske Jomfruøer' },
    { 'code': 'JO', 'name': 'Jordan' },
    { 'code': 'KH', 'name': 'Cambodja' },
    { 'code': 'CM', 'name': 'Cameroun' },
    { 'code': 'CV', 'name': 'Kap Verde' },
    { 'code': 'BQ', 'name': 'Nederlandske Antiller' },
    { 'code': 'KZ', 'name': 'Kasakhstan' },
    { 'code': 'KE', 'name': 'Kenya' },
    { 'code': 'CN', 'name': 'Kina' },
    { 'code': 'KG', 'name': 'Kirgisistan' },
    { 'code': 'KI', 'name': 'Kiribati' },
    { 'code': 'CC', 'name': 'Cocosøerne' },
    { 'code': 'KM', 'name': 'Comorerne' },
    { 'code': 'CG', 'name': 'Congo' },
    { 'code': 'CD', 'name': 'Congo Demokratiske Republik Congo' },
    { 'code': 'HR', 'name': 'Kroatien' },
    { 'code': 'KW', 'name': 'Kuwait' },
    { 'code': 'CY', 'name': 'Cypern' },
    { 'code': 'LA', 'name': 'Laos' },
    { 'code': 'LV', 'name': 'Letland' },
    { 'code': 'LS', 'name': 'Lesotho' },
    { 'code': 'LB', 'name': 'Libanon' },
    { 'code': 'LR', 'name': 'Liberia' },
    { 'code': 'LY', 'name': 'Libyen' },
    { 'code': 'LI', 'name': 'Liechtenstein' },
    { 'code': 'LT', 'name': 'Litauen' },
    { 'code': 'LU', 'name': 'Luxembourg' },
    { 'code': 'MO', 'name': 'Macao' },
    { 'code': 'MG', 'name': 'Madagaskar' },
    { 'code': 'MK', 'name': 'Makedonien' },
    { 'code': 'MW', 'name': 'Malawi' },
    { 'code': 'MY', 'name': 'Malaysia' },
    { 'code': 'MV', 'name': 'Maldiverne' },
    { 'code': 'ML', 'name': 'Mali' },
    { 'code': 'MT', 'name': 'Malta' },
    { 'code': 'MA', 'name': 'Marokko' },
    { 'code': 'MH', 'name': 'Marshalløerne' },
    { 'code': 'MQ', 'name': 'Martinique' },
    { 'code': 'MR', 'name': 'Mauretanien' },
    { 'code': 'MU', 'name': 'Mauritius' },
    { 'code': 'YT', 'name': 'Mayotte' },
    { 'code': 'MX', 'name': 'Mexico' },
    { 'code': 'FM', 'name': 'Mikronesien' },
    { 'code': 'MD', 'name': 'Moldova' },
    { 'code': 'MC', 'name': 'Monaco' },
    { 'code': 'MN', 'name': 'Mongoliet' },
    { 'code': 'ME', 'name': 'Montenegro' },
    { 'code': 'MS', 'name': 'Montserrat' },
    { 'code': 'MZ', 'name': 'Mozambique' },
    { 'code': 'MM', 'name': 'Burma' },
    { 'code': 'NA', 'name': 'Namibia' },
    { 'code': 'NR', 'name': 'Nauru' },
    { 'code': 'NL', 'name': 'Holland' },
    { 'code': 'NP', 'name': 'Nepal' },
    { 'code': 'NZ', 'name': 'New Zealand' },
    { 'code': 'NI', 'name': 'Nicaragua' },
    { 'code': 'NE', 'name': 'Niger' },
    { 'code': 'NG', 'name': 'Nigeria' },
    { 'code': 'NU', 'name': 'Niue' },
    { 'code': 'KP', 'name': 'Nordkorea' },
    { 'code': 'MP', 'name': 'Nordmarianerne' },
    { 'code': 'NF', 'name': 'Norfolk Island' },
    { 'code': 'NO', 'name': 'Norge' },
    { 'code': 'NC', 'name': 'Ny Kaledonien' },
    { 'code': 'OM', 'name': 'Oman' },
    { 'code': 'PK', 'name': 'Pakistan' },
    { 'code': 'PW', 'name': 'Palau' },
    { 'code': 'PS', 'name': 'Palæstina' },
    { 'code': 'PA', 'name': 'Panama' },
    { 'code': 'PG', 'name': 'Papua Ny Guinea' },
    { 'code': 'PY', 'name': 'Paraguay' },
    { 'code': 'PE', 'name': 'Peru' },
    { 'code': 'PN', 'name': 'Pitcairn' },
    { 'code': 'PL', 'name': 'Polen' },
    { 'code': 'PT', 'name': 'Portugal' },
    { 'code': 'PR', 'name': 'Puerto Rico' },
    { 'code': 'QA', 'name': 'Qatar' },
    { 'code': 'RE', 'name': 'Réunion' },
    { 'code': 'RO', 'name': 'Rumænien' },
    { 'code': 'RU', 'name': 'Rusland' },
    { 'code': 'RW', 'name': 'Rwanda' },
    { 'code': 'SH', 'name': 'Sankt Helena' },
    { 'code': 'KN', 'name': 'Saint Kitts og Nevis' },
    { 'code': 'LC', 'name': 'Saint Lucia' },
    { 'code': 'PM', 'name': 'Saint - Pierre og Miquelon' },
    { 'code': 'VC', 'name': 'Saint Vincent og Grenadinerne' },
    { 'code': 'SB', 'name': 'Salomonøerne' },
    { 'code': 'WS', 'name': 'Samoa' },
    { 'code': 'SM', 'name': 'San Marino' },
    { 'code': 'ST', 'name': 'São Tomé og Príncipe' },
    { 'code': 'SA', 'name': 'Saudi - Arabien' },
    { 'code': 'SN', 'name': 'Senegal' },
    { 'code': 'CF', 'name': 'Centralafrikanske Republik' },
    { 'code': 'RS', 'name': 'Serbien' },
    { 'code': 'SC', 'name': 'Seychellerne' },
    { 'code': 'SL', 'name': 'Sierra Leone' },
    { 'code': 'SG', 'name': 'Singapore' },
    { 'code': 'SX', 'name': 'Sint Maarten' },
    { 'code': 'SK', 'name': 'Slovakiet' },
    { 'code': 'SI', 'name': 'Slovenien' },
    { 'code': 'SO', 'name': 'Somalia' },
    { 'code': 'ES', 'name': 'Spanien' },
    { 'code': 'LK', 'name': 'Sri Lanka' },
    { 'code': 'GB', 'name': 'Storbritannien' },
    { 'code': 'SD', 'name': 'Sudan' },
    { 'code': 'SR', 'name': 'Surinam' },
    { 'code': 'SJ', 'name': 'Norge' },
    { 'code': 'SE', 'name': 'Sverige' },
    { 'code': 'CH', 'name': 'Schweiz' },
    { 'code': 'SZ', 'name': 'Swaziland' },
    { 'code': 'SY', 'name': 'Syrien' },
    { 'code': 'ZA', 'name': 'Sydafrika' },
    { 'code': 'GS', 'name': 'South Georgia og South Sandwich Islands' },
    { 'code': 'KR', 'name': 'Sydkorea' },
    { 'code': 'SS', 'name': 'Sydsudan' },
    { 'code': 'TW', 'name': 'Republikken Kina Taiwan' },
    { 'code': 'TJ', 'name': 'Tadsjikistan' },
    { 'code': 'TZ', 'name': 'Tanzania' },
    { 'code': 'TH', 'name': 'Thailand' },
    { 'code': 'TL', 'name': 'Østtimor' },
    { 'code': 'TG', 'name': 'Togo' },
    { 'code': 'TK', 'name': 'Tokelau' },
    { 'code': 'TO', 'name': 'Tonga' },
    { 'code': 'TT', 'name': 'Trinidad og Tobago' },
    { 'code': 'TD', 'name': 'Tchad' },
    { 'code': 'CZ', 'name': 'Tjekkiet' },
    { 'code': 'TN', 'name': 'Tunesien' },
    { 'code': 'TR', 'name': 'Tyrkiet' },
    { 'code': 'TM', 'name': 'Turkmenistan' },
    { 'code': 'TC', 'name': 'Turks - og Caicosøerne' },
    { 'code': 'DE', 'name': 'Tyskland' },
    { 'code': 'TV', 'name': 'Tuvalu' },
    { 'code': 'UG', 'name': 'Uganda' },
    { 'code': 'UA', 'name': 'Ukraine' },
    { 'code': 'HU', 'name': 'Ungarn' },
    { 'code': 'AE', 'name': 'Forenede Arabiske Emirater' },
    { 'code': 'UM', 'name': 'USA\'s ydre småøer USA\'s ydre småøer' },
    { 'code': 'UY', 'name': 'Uruguay' },
    { 'code': 'UZ', 'name': 'Usbekistan' },
    { 'code': 'VU', 'name': 'Vanuatu' },
    { 'code': 'VA', 'name': 'Vatikanstaten' },
    { 'code': 'VE', 'name': 'Venezuela' },
    { 'code': 'EH', 'name': 'Vestsahara' },
    { 'code': 'VN', 'name': 'Vietnam' },
    { 'code': 'WF', 'name': 'Wallis og Futuna' },
    { 'code': 'ZM', 'name': 'Zambia' },
    { 'code': 'ZW', 'name': 'Zimbabwe' },
    { 'code': 'AT', 'name': 'Østrig' },
    { 'code': 'AX', 'name': 'Ålandsøerne' }
];
